// extracted by mini-css-extract-plugin
export var title = "styles-module--title--7f10a";